module.exports = __webpack_public_path__ + "img/drawing_huaniao.7a0a2e75.png";